<template>
  <div>
    <h2>{{ $t('db.recipient.modal.import.import_title') }}</h2>

    <ul class="b-select-fields">
      <li v-for="(item, index) in fields" :key="item.name">
        <label>
          {{ item }}
        </label>
        <i-select @on-change="value => changeCheckbox(value, index)">
          <i-option
            v-for="(field, name) in fields_title"
            :key="`${item}-${field}-key`"
            :value="name"
            :label="field"
            :disabled="isDisabled(name)"
          />
        </i-select>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'SelectFields',
    props: {
      fields: {
        type: Array,
        required: true
      }
    },

    data: function() {
      return {
        columns: {},
        selected_fields: {},
        set_fields: {},
        select: {},
        disabled_fields: [],
        fields_title: {
          number: this.$t('db.recipient.modal.import.field_title.number'),
          email: this.$t('db.recipient.modal.import.field_title.email'),
          first_name: this.$t('db.recipient.modal.import.field_title.first_name'),
          last_name: this.$t('db.recipient.modal.import.field_title.last_name'),
          age: this.$t('db.recipient.modal.import.field_title.age'),
          sex: this.$t('db.recipient.modal.import.field_title.sex'),
          country: this.$t('db.recipient.modal.import.field_title.country'),
          city: this.$t('db.recipient.modal.import.field_title.city'),
          birthdate: this.$t('db.recipient.modal.import.field_title.birthdate'),
          custom1: this.$t('db.recipient.modal.import.field_title.custom1'),
          custom2: this.$t('db.recipient.modal.import.field_title.custom2'),
          custom3: this.$t('db.recipient.modal.import.field_title.custom3'),
          custom4: this.$t('db.recipient.modal.import.field_title.custom4'),
          custom5: this.$t('db.recipient.modal.import.field_title.custom5')
        }
      };
    },

    mounted() {
      this.fields.forEach((item, index) => {
        this.set_fields[item] = index;
      });
    },

    methods: {
      changeCheckbox(value, index) {
        if (value === 'skip') return;

        for (let prop in this.columns) {
          if (this.columns[prop] === index + 1) {
            delete this.columns[prop];
            this.disabled_fields.splice(this.disabled_fields.indexOf(prop), 1);
          }
        }

        this.columns[value] = index + 1;
        this.disabled_fields.push(value);

        this.$emit('selectedFields', this.columns);
      },

      isDisabled(name) {
        return this.disabled_fields.includes(name);
      }
    }
  };
</script>

<style lang="scss">
  ul.b-select-fields {
    list-style: none;
    display: block;
    margin-top: 20px;

    li {
      width: 100%;
      display: flex;
      margin-top: 10px;

      label {
        width: 60%;
      }

      span {
        margin-right: 5px;
      }
    }
  }
</style>
